import { parseDateKey } from './format-date-key';

// `new Date('yyyy-MM-dd')` parses as UTC midnight, landing on the previous local day west of UTC.
export const parseEventBoundary = (value: string, allDay: boolean): Date =>
  allDay ? parseDateKey(value) : new Date(value);
